import { SubscriberViewsInDto, GetViewsBySubscriberOutDto } from "../../../types/post-views.dto";

export const GET_SUBSCRIBER_VIEWS = "GET_SUBSCRIBER_VIEWS";
export const GET_SUBSCRIBER_VIEWS_SUCCESS = "GET_SUBSCRIBER_VIEWS_SUCCESS";
export const GET_SUBSCRIBER_VIEWS_ERROR = "GET_SUBSCRIBER_VIEWS_ERROR";
export const RESET_SUBSCRIBER_VIEWS = "RESET_SUBSCRIBER_VIEWS";

export interface GetSubscriberViews {
  type: typeof GET_SUBSCRIBER_VIEWS;
  payload: GetViewsBySubscriberOutDto;
}

export interface GetSubscriberViewsSuccess {
  type: typeof GET_SUBSCRIBER_VIEWS_SUCCESS;
  payload: SubscriberViewsInDto;
}

export interface GetSubscriberViewsError {
  type: typeof GET_SUBSCRIBER_VIEWS_ERROR;
  payload: string | boolean;
}

export interface ResetSubscriberViews {
  type: typeof RESET_SUBSCRIBER_VIEWS;
  payload: null;
}

export interface State {
  data: SubscriberViewsInDto | null;
  states: {
    success: boolean;
    loading: boolean;
    error: boolean | string;
  };
}

export const initialState: State = {
  data: null,
  states: {
    success: false,
    loading: false,
    error: false,
  },
};

export type Actions = GetSubscriberViews | GetSubscriberViewsSuccess | GetSubscriberViewsError | ResetSubscriberViews;

